import { Component, OnInit, Inject, Optional, TemplateRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NbDialogService } from '@nebular/theme';
import { AddNotesComponent } from '../add-notes/add-notes.component';
import { CaseManagementService } from '../../../services/caseManagement.service';

@Component({
  selector: 'view-notes',
  templateUrl: './view-notes.component.html',
  styleUrls: ['./view-notes.component.scss']
})
export class ViewNotesComponent implements OnInit {
  loading: boolean;
  viewFullNotes: any;
  woServiceKey: number;
  isDemo: boolean = false;


  constructor(
    public dialogRef: MatDialogRef<ViewNotesComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private caseManagementService: CaseManagementService,
    private dialogService: NbDialogService,
    public dialog: MatDialog,
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {

    this.isDemo = (sessionStorage.getItem("isDemo")) ? true : false;
    this.woServiceKey = this.caseManagementService.getWorkOrderKey();
    if (this.woServiceKey == undefined) {
      this.woServiceKey = this.data.data;
    }
    this.getViewFullNotes();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getViewFullNotes() {
    this.loading = true;
    if (this.isDemo) {
      const caseSummaryReport = sessionStorage.getItem('caseSummaryReport');
      const summaryReport = JSON.parse(caseSummaryReport);

      this.viewFullNotes = [{
        wONdAdded: summaryReport.WoSubmitDate,
        wONtextNote: "Test WO is created from customer portal"
      }];
      this.loading = false;
    } else {
      this.caseManagementService.getWoViewNotesDetails(this.woServiceKey).subscribe(res => {
        this.viewFullNotes = res;      
        this.loading = false;
      });
    }

  }

  removeNotes(wONlKey) {
    var noteKey = wONlKey;
    var retVal = confirm("Do you want to remove note ?");
    if (retVal == true) {
      this.loading = true;
      this.caseManagementService.removeWoNoteDetails(noteKey).subscribe(res => {
        if (res == 1) {
          alert("Note removed successfully.!");
          this.loading = false;
          this.getViewFullNotes();
        }
        this.loading = false;
      });
    }
  }

  addWoNote() {
    // this.dialogService.open(dialog, { context: "" });
    let dialogRef = this.dialog.open(AddNotesComponent, {
      hasBackdrop: true,
      data: {
        WONumber: this.woServiceKey
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.getViewFullNotes();
      }

    });
  }

}

